<template>
  <v-btn
    class="custom-btn"
    :class="{ 'custom-btn--transparent': transparent, 'custom-btn--initial-width': initial }"
    :style="{ width: width }"
    color="transparent"
    :disabled="disabled"
    @click="$emit('click')"
    depressed
  >
    <slot />
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ButtonSecondary",
  props: {
    title: String,
    width: String,
    disabled: Boolean,
    tooltip: String,
    transparent: {
      type: Boolean,
      default: false,
    },
    initial: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.custom-btn {
  font-family: Work Sans, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.04px;
  width: $btn-width;
  height: $btn-height !important;
  overflow: hidden;
  border-radius: $border-radius-small;
}

.custom-btn--transparent {
  background-color: transparent !important;
}

.custom-btn--initial-width {
  width: initial !important;
}

.theme--dark .v-btn.custom-btn--transparent.v-btn--has-bg,
.theme--light .v-btn.custom-btn--transparent.v-btn--has-bg {
  background-color: transparent !important;
}

.custom-btn.v-btn--disabled.v-btn--has-bg {
  background-color: var(--v-background-medium-base) !important;
}
</style>

<style lang="scss">
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.v-application.theme--light {
  .custom-btn {
    color: var(--v-content-dark-base);
  }
}

.v-application.theme--dark {
  .custom-btn {
    color: var(--v-content-light-base);
  }
}
</style>
